import React, {Component} from 'react'
import { connect } from 'react-redux';
import ReactMarkdown from 'react-markdown'
import { injectIntl, intlShape } from 'react-intl'
import { fetchReservationTexts } from '../../redux/actions';
import get from 'lodash/get';

import ReservationForm from '../../components/ReservationForm'

class ReservationPage extends Component {
  constructor(props){
    super(props)
    this.state = {
      modalUrl: null,
      modalOpen: false,
	  showForm: false
    }
  }


  componentDidMount() {
    if (!this.props.reservationTexts) {
      this.props.fetchReservationTexts(this.props.intl.locale);
    }
  }

  render(){
    return(
      <div className="reservation-body container">
		  <h3>{this.props.intl.messages["general.bookTable"]}</h3>
			
	      <a href={this.props.intl.locale==='fi' ? 'https://www.sevenrooms.com/reservations/gaijin' : 'https://www.sevenrooms.com/reservations/gaijin?lang=en'} target="_blank" className="btn" rel="noopener noreferrer">{this.props.intl.messages["general.bookOnline"]}</a>

		  <a className="btn" onClick={()=>this.setState({showForm: !this.state.showForm})}>{this.props.intl.messages["general.bookFormBtn"]}</a>
			
		  {this.state.showForm && (
			  <div className="reservation_form_container">
				  <ReservationForm />

				  {
					get(this.props, 'reservationTexts.groupReservationInfo') &&
					<ReactMarkdown source={get(this.props, 'reservationTexts.groupReservationInfo')} softBreak="br" />
				  }
			  </div>
		  )}

	      {
            get(this.props, 'reservationTexts.onlineBookingInfo') &&
            <ReactMarkdown source={get(this.props, 'reservationTexts.onlineBookingInfo')} softBreak="br" />
          }
      </div>
    )
  }
}

ReservationPage.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  reservationTexts: state.reservationTexts,
});

const mapDispatchToProps = {
  fetchReservationTexts,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ReservationPage));


// WEBPACK FOOTER //
// ./src/containers/ContentPages/ReservationPage.js